// extracted by mini-css-extract-plugin
module.exports = {"bottomAd_box":"bottomAd_box-1t7ihQxF","bottomAd":"bottomAd-1IAIq6-F"};